import { AtMentionsViewState } from '../store/schema/AtMentionsViewState';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import { action } from 'satcheljs/lib/legacy';

export default action('addMentionAddedRecipient')(function addMentionAddedRecipient(
    viewState: AtMentionsViewState,
    recipient: FindRecipientPersonaType
) {
    viewState.mentionsAddedRecipients.push(recipient.EmailAddress.EmailAddress);
});
